module.exports = __webpack_public_path__ + "static/media/Wayfair_logo.8020a0fa.svg";